import CheckIcon from '@mui/icons-material/Check';
import { styled } from '@mui/material/styles';

export const SmallCheckIcon = styled(CheckIcon)(({ theme }) => ({
  fontSize: '1rem',
  verticalAlign: 'middle',
  marginLeft: theme.spacing(1),
}));
